module.exports = __webpack_public_path__ + "static/media/doctorImage.4e3af698.svg";